export default __webpack_public_path__ + "static/media/tids.144df6d3.svg";